import React from 'react';
import { useParams } from 'react-router-dom';
import ConsentHistory from '../components/consent/ConsentHistory';
import './ConsentPage.css';

const ConsentPage = () => {
  const { applicationId } = useParams();

  // Mock data
  const mockHistory = [
    { id: 'c1', type: 'IDENTITY', granted: true, noticeVersion: '1.0', date: '2023-10-20T10:05:00Z', withdrawn: false },
    { id: 'c2', type: 'CREDIT', granted: true, noticeVersion: '1.0', date: '2023-10-20T10:05:00Z', withdrawn: false },
    { id: 'c3', type: 'REUSE', granted: false, noticeVersion: '1.0', date: '2023-10-20T10:05:00Z', withdrawn: false }
  ];

  const handleWithdraw = async (id, reason) => {
    console.log(`Withdrawing ${id} because ${reason}`);
    // Update state/API here
  };

  return (
    <div className="consent-page">
      <div className="consent-page__header">
        <h1>Manage Consents</h1>
        <p className="helper-text">Application ID: {applicationId}</p>
      </div>

      <ConsentHistory history={mockHistory} onWithdraw={handleWithdraw} />
      
      <div className="consent-page__footer">
        <a href="/privacy" target="_blank" rel="noopener noreferrer" className="privacy-link">
          View Privacy Notice
        </a>
      </div>
    </div>
  );
};

export default ConsentPage;
